"use client";

import { useReportWebVitals } from "next/web-vitals";
import { sendGAEvent, sendGTMEvent } from "@next/third-parties/google";
import useTrackPath from "@/lib/useTrackPath";
import { PropsWithChildren } from "react";
export function WebVitals({ children }: PropsWithChildren) {
  useTrackPath();
  useReportWebVitals((metric) => {
    // Customize the event data for GTM
    const eventData = {
      event: "web_vitals",
      eventCategory: "Web Vitals",
      eventAction: metric.name, // e.g., FCP, LCP, CLS
      eventValue: metric.value, // Metric value
      metricId: metric.id, // Metric unique ID
      rating: metric.rating,
      non_interaction: true, // avoids affecting bounce rate.
    };

    // Send to Google Tag Manager
    sendGTMEvent(eventData);
    // console.log(metric);
  });
  return <>{children}</>;
}
